/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Flags Scheduling API
 * This page documents how to use Optimizely Flags Scheduling API. These APIs allow you to turn a flag on/off, turn a  rule on/off, change the traffic allocation of a rule and change the audience conditions of a rule.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  FlagScheduleAction,
  FlagScheduleActionFromJSON,
  FlagScheduleActionFromJSONTyped,
  FlagScheduleActionToJSON,
  ScheduleTimeResponse,
  ScheduleTimeResponseFromJSON,
  ScheduleTimeResponseFromJSONTyped,
  ScheduleTimeResponseToJSON,
  StatusHistoryItem,
  StatusHistoryItemFromJSON,
  StatusHistoryItemFromJSONTyped,
  StatusHistoryItemToJSON,
} from './';

/**
 *
 * @export
 * @interface Approval
 */
export interface Approval {
  /**
   *
   * @type {boolean}
   * @memberof Approval
   */
  archived: boolean;
  /**
   * The name of the entity this Approval relates to (e.g. Flag Name).
   * @type {string}
   * @memberof Approval
   */
  entity_name: string;
  /**
   * The key of the entity this Approval relates to (e.g. Flag Key).
   * @type {string}
   * @memberof Approval
   */
  entity_key: string;
  /**
   * The ID of the entity this Approval relates to (e.g. Flag ID).
   * @type {number}
   * @memberof Approval
   */
  entity_id: number;
  /**
   * The approval ID.
   * @type {number}
   * @memberof Approval
   */
  id: number;
  /**
   * The environment where the action is happening.
   * @type {string}
   * @memberof Approval
   */
  environment: string;
  /**
   * The ID of environment where the action is happening.
   * @type {number}
   * @memberof Approval
   */
  environment_id: number;
  /**
   * The current status ID.
   * @type {number}
   * @memberof Approval
   */
  current_status_id: number;
  /**
   * Schedule details.
   * @type {ScheduleTimeResponse}
   * @memberof Approval
   */
  schedule?: ScheduleTimeResponse;
  /**
   * List of actions to be performed.
   * @type {Array<FlagScheduleAction>}
   * @memberof Approval
   */
  actions: Array<FlagScheduleAction>;
  /**
   * History of status changes.
   * @type {Array<StatusHistoryItem>}
   * @memberof Approval
   */
  status_history: Array<StatusHistoryItem>;
  /**
   * Timestamp when the schedule was created.
   * @type {Date}
   * @memberof Approval
   */
  created_at: Date;
  /**
   * The Timestamp when the schedule updated.
   * @type {string}
   * @memberof Approval
   */
  updated_at: Date;
  /**
   * The user who created the schedule.
   * @type {string}
   * @memberof Approval
   */
  created_by: string;
  /**
   * The status of the scheduled job.
   * @type {string}
   * @memberof Approval
   */
  schedule_job_status: ApprovalScheduleJobStatusEnum;
}

export function ApprovalFromJSON(json: any): Approval {
  return ApprovalFromJSONTyped(json, false);
}

export function ApprovalFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Approval {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    archived: json['archived'],
    entity_name: json['entity_name'],
    entity_key: json['entity_key'],
    entity_id: json['entity_id'],
    id: json['id'],
    environment: json['environment'],
    environment_id: json['environment_id'],
    current_status_id: json['current_status_id'],
    schedule: !exists(json, 'schedule')
      ? undefined
      : ScheduleTimeResponseFromJSON(json['schedule']),
    actions: (json['actions'] as Array<any>).map(FlagScheduleActionFromJSON),
    status_history: (json['status_history'] as Array<any>).map(
      StatusHistoryItemFromJSON
    ),
    created_at: new Date(json['created_at']),
    updated_at: new Date(json['updated_at']),
    created_by: json['created_by'],
    schedule_job_status: json['schedule_job_status'],
  };
}

export function ApprovalToJSON(value?: Approval | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    archived: value.archived,
    entity_name: value.entity_name,
    entity_key: value.entity_key,
    entity_id: value.entity_id,
    id: value.id,
    environment: value.environment,
    environment_id: value.environment_id,
    current_status_id: value.current_status_id,
    schedule: ScheduleTimeResponseToJSON(value.schedule),
    actions: (value.actions as Array<any>).map(FlagScheduleActionToJSON),
    status_history: (value.status_history as Array<any>).map(
      StatusHistoryItemToJSON
    ),
    created_at: value.created_at.toISOString(),
    updated_at: value.updated_at.toISOString(),
    created_by: value.created_by,
    schedule_job_status: value.schedule_job_status,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ApprovalScheduleJobStatusEnum {
  Pending = 'pending',
  InQueue = 'in_queue',
  FailedToQueue = 'failed_to_queue',
  Canceled = 'canceled',
  Completed = 'completed',
  Failed = 'failed',
  PartiallyFailed = 'partially_failed',
}
